import { StytchB2BUIClient } from '@stytch/vanilla-js/b2b';

const STYTCH_PUBLIC_TOKEN = process.env.NODE_ENV === 'production' 
  ? 'public-token-live-56b7533b-8661-4bfd-aebf-4a223ff70b83' 
  : 'public-token-test-0125c507-63e4-4d2e-a320-78a0207121a6';

export const REDIRECT_URL = process.env.NODE_ENV === 'production' ?
    'https://app.sonicspec.com/authenticate' : 'http://localhost:5173/projects';

export const stytch = new StytchB2BUIClient(STYTCH_PUBLIC_TOKEN);